/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string, func, node, bool, shape, arrayOf, number,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import GraphqlProductImageUI from './Partials/GraphqlProductImageUI';
import GraphqlPDPDataWrapper from './Partials/GraphqlPDPDataWrapper';
import GraphqlClubDescription from './Partials/GraphqlClubDescription/GraphqlClubDescription';
import {
    clubComponentType, selectedSkuType, UpsellType, productType, skuDataType, skuConfigType, passportImageType, deliveryDataType, addToCartDataType,
} from './Partials/common/types';

const ClubPDPContainerMaxWidth = 1080;

const styles = (theme) => ({

    breadcrumbs: {
        maxWidth: ClubPDPContainerMaxWidth,
        margin: '0 auto',
    },
    contentTop: {
        display: 'flex',
        margin: '0px auto',
        maxWidth: ClubPDPContainerMaxWidth,
        color: theme.palette.black,
        [theme.breakpoints.down('md')]: {
            marginTop: '25px',
        },
        '& .add-to-cart-container': {
            width: '95%',
            margin: '0 auto',
        },
    },
    contentLeft: {
        width: '100%',
        maxWidth: 480,
        [theme.breakpoints.down('md')]: {
            maxWidth: 'none',
            minWidth: 'auto',
            float: 'left',
        },
    },
    contentRight: {
        width: '100%',
        maxWidth: 510,
    },
    imageSection: {
        paddingRight: 15,
        [theme?.breakpoints?.down('sm')]: {
            paddingRight: 0,
        },
    },
});

const GraphqlClubProductPage = ({
    product,
    location,
    selectedSku,
    classes,
    presentation_family,
    handleSkuChange,
    sortedData,
    skuConfig,
    deliveryData,
    breadCrumbArray,
    passportMemberImg,
    productUrl,
    breadcrumbs,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    clubUpsells,
    clubComponents,
    shortDescription,
    longDescription,
    selectedClubUpsells,
    changeClubUpsell,
    hasAddons,
    handlePersonalizeInputChange,
    getUpdatedPersonalizedProdData,
    disableAddToCart,
    personalizedData,
    personalization,
    isAddToCartEnabled,
    handleMiniCartModalClick,
    mobileAgeVerificationOpen,
    handleMobileAgeVerification,
    addToCartData,
    hasWine,
}) => (
    <>
        <div className={classes.breadcrumbs}>{breadcrumbs}</div>
        <Grid container direction="row" justify="space-between" className={classes.contentTop}>
            <Grid xs={12} sm={12} lg={6} md={6} item>
                <div className={classes.imageSection}>
                    <GraphqlProductImageUI
                        isClubProduct
                        data={product}
                        clubComponents={clubComponents}
                        selectedSku={selectedSku}
                        location={location}
                        presentation_family={presentation_family}
                    />
                </div>
            </Grid>
            <Grid xs={12} lg={6} md={6} item>
                <GraphqlPDPDataWrapper
                    clubProduct
                    product={product}
                    clubUpsells={clubUpsells}
                    skuMonths={skuMonths}
                    changeClubMonth={changeClubMonth}
                    changeClubLength={changeClubLength}
                    skuConfig={skuConfig}
                    deliveryData={deliveryData}
                    breadCrumbArray={breadCrumbArray}
                    presentation_family={presentation_family}
                    selectedSku={selectedSku}
                    handleSkuChange={handleSkuChange}
                    sortedData={sortedData}
                    passportMemberImg={passportMemberImg}
                    productUrl={productUrl}
                    location={location}
                    selectedClubUpsells={selectedClubUpsells}
                    changeClubUpsell={changeClubUpsell}
                    hasAddons={hasAddons}
                    handlePersonalizeInputChange={handlePersonalizeInputChange}
                    disableAddToCart={disableAddToCart}
                    getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                    personalizedData={personalizedData}
                    personalization={personalization}
                    isAddToCartEnabled={isAddToCartEnabled}
                    handleMiniCartModalClick={handleMiniCartModalClick}
                    mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                    handleMobileAgeVerification={handleMobileAgeVerification}
                    addToCartData={addToCartData}
                    hasWine={hasWine}
                />
            </Grid>
        </Grid>
        <div className={classes.contentTop}>
            <GraphqlClubDescription
                isPassportEligible={product?.isPassportEligible}
                shortDescription={shortDescription}
                clubComponents={clubComponents}
                longDescription={longDescription}
                productName={product?.name}
            />
        </div>
    </>
);
GraphqlClubProductPage.defaultProps = {
    longDescription: '',
    shortDescription: '',
    selectedClubUpsells: null,
    getUpdatedPersonalizedProdData: () => { },
    handlePersonalizeInputChange: () => { },
    hasAddons: false,
    disableAddToCart: false,
    isAddToCartEnabled: true,
    personalizedData: {},
    personalization: {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: func,
    addToCartData: {},
    hasWine: false,
};

GraphqlClubProductPage.propTypes = {
    classes: object.isRequired,
    location: object.isRequired,
    product: productType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    presentation_family: string.isRequired,
    handleSkuChange: func.isRequired,
    sortedData: skuDataType.isRequired,
    skuConfig: skuConfigType.isRequired,
    deliveryData: deliveryDataType.isRequired,
    breadCrumbArray: node.isRequired,
    passportMemberImg: passportImageType.isRequired,
    productUrl: string.isRequired,
    breadcrumbs: node.isRequired,
    skuMonths: object.isRequired, // dynamic month named keys
    changeClubMonth: func.isRequired,
    changeClubLength: func.isRequired,
    clubUpsells: UpsellType.isRequired,
    clubComponents: clubComponentType.isRequired,
    longDescription: string,
    shortDescription: string,
    changeClubUpsell: func.isRequired,
    selectedClubUpsells: string,
    hasAddons: bool,
    handlePersonalizeInputChange: func,
    handleMiniCartModalClick: func.isRequired,
    getUpdatedPersonalizedProdData: func,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    personalization: shape({
        lines: arrayOf(
            shape({
                lineNumber: number,
                maxChars: number,
            }),
        ),
    }),
    mobileAgeVerificationOpen: bool,
    hasWine: bool,
    handleMobileAgeVerification: () => {},
    addToCartData: addToCartDataType,
};

export default (withStyles(styles)(GraphqlClubProductPage));
